import { useState } from "react";
import { api } from "api";

const ENDPOINT = "prod_bodega_reajustes_inventario";

export const ReajustesTabApi = () => {
    const [cargando, setCargando] = useState(false);

    // reajustes ya aplicados a la existencia, o sea los de cierres cerrados
    const getReajustes = async (params) => {
        try {
            setCargando(true);
            const response = await api.get(`${ENDPOINT}/historial`, params);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    // los mismos productos con los que se arman las filas de un cierre
    const getProductos = async (params) => {
        return api
            .get("prod_bodega_inventario_inicial/productos", params)
            .then((data) => {
                if (data) return data.results;
                return [];
            })
            .catch(() => {
                return [];
            });
    };

    return {
        getReajustes,
        getProductos,

        cargando,
    };
};
